import type { PixelCrop } from 'react-image-crop';

export async function cropImageToBlob(
  image: HTMLImageElement,
  crop: PixelCrop,
  mimeType = 'image/jpeg',
  quality = 0.92,
): Promise<Blob> {
  if (crop.width <= 0 || crop.height <= 0) {
    throw new Error('Select a crop area before confirming.');
  }

  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = Math.round(crop.width * scaleX);
  canvas.height = Math.round(crop.height * scaleY);

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Unable to prepare the image crop.');
  }

  context.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height,
  );

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
          return;
        }

        reject(new Error('Unable to prepare the image crop.'));
      },
      mimeType,
      quality,
    );
  });
}
